import React, { Component } from 'react';
import { connect } from 'react-redux';
import CheckoutComponent from './components/CheckoutComponent';
import { push } from '../../common/actions/navigate';
import { clearBundle/*, getSalesTax */} from './actions';
import { reset } from '../Steppers/actions';
import { challengesWithItemsSelector, challengesSalesTaxableSelector } from './selectors';

class Checkout extends Component {
	_clearBundle = () => {
		this.props.reset();
		this.props.clearBundle();
		this.props.push('/races');
	}

	shouldComponentUpdate(nextProps, _) {
		return (this.props.challenge.cart.bundle.challenges.length !== nextProps.challenge.cart.bundle.challenges.length) ||
			(this.props.challenge.salesTax.geoCounty !== nextProps.challenge.salesTax.geoCounty);
	}

	render() {
		if (!this.props.challenge.cart.bundle ||
			this.props.challenge.cart.bundle === null ||
			this.props.challenge.cart.bundle.challenges.length < 1 ||
			this.props.challenge.cart.isNew ||
			this.props.challenge.cart.bundle.paymentId !== null ||
			this.props.challenge.cart.challengeAthleteId !== null) {
			return null;
		}
		else {
			var challengeUrl;
			var initialStep;
			var isSwag;

			//If the cart contains a shippable product and there's no address, OR
			//if the cart contains anything that is subject to sales tax, THEN
			//go to the shipping page, to either collect the address, or recalculate tax
			if ((this.props.challengesSalesTaxable && this.props.challengesSalesTaxable.length > 0) ||
				(this.props.challengesWithItems && this.props.challengesWithItems.length > 0 && (this.props.challenge.cart.address === null || this.props.challenge.cart.city === null || this.props.challenge.cart.zip === null))) {
				const challenge = this.props.challengesWithItems && this.props.challengesWithItems[0] ? this.props.challengesWithItems[0] : this.props.challengesSalesTaxable[0]
				challengeUrl = challenge.challengeUrl;
				initialStep = 'shipping';
				isSwag = challenge.isSwag;
			}
			else {
				challengeUrl = this.props.challenge.cart.bundle.challenges[0].challengeUrl;
				initialStep = 'checkout'; //should be 'checkout', but it's running for bundles that should be going to shipping
				isSwag = this.props.challenge.cart.bundle.challenges[0].isSwag;
			}
			return (
				<CheckoutComponent
					push={this.props.push}
					challengeUrl={challengeUrl}
					initialStep={initialStep}
					count={this.props.challenge.cart.bundle.challenges.length}
					type={this.props.type}
					onClearBundle={this._clearBundle}
					isSwag={isSwag}
				/>
			);
		}
	}
}

function bindAction(dispatch) {
	return {
		push: (route, params) => dispatch(push(route, params)),
		clearBundle: () => dispatch(clearBundle()),
		reset: () => dispatch(reset())
		//getSalesTax: () => dispatch(getSalesTax())
	};
}

function mapStateToProps(state) {
	return {
		challenge: state.challenge,
		challengesWithItems: challengesWithItemsSelector(state),
		challengesSalesTaxable: challengesSalesTaxableSelector(state)
		//bundleChallenges: bundleChallengesSelector(state)
	};
}

export default connect(mapStateToProps, bindAction)(Checkout);
